import ResetPasswordForm from "./ResetPassword";

export default ResetPasswordForm;
